import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesFranchiseePrivate } from 'common/models/routesModel';

export const RootFranchiseePage: React.FC = () => <Redirect to={ERoutesFranchiseePrivate.StoreList} />;
